import { useCheckUserRole } from '@/components/HOC/UserRoleGuard';
import { GenericPageHeader } from '@/components/layout/page-header';
import { CompetenceProfilePage } from '@/pages/competence/CompetenceProfilePage';
import { useGlobalStoreSelector } from '@/stores/global.store';
import { getRouteApi, createFileRoute } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { useLingui, Trans } from '@lingui/react/macro';

const routeApi = getRouteApi('/_authenticated/_app/competence/user/$userId');

function CompetenceUserProfileRoute() {
	const { t } = useLingui();
	const { userId } = routeApi.useParams();
	const isAdmin = useCheckUserRole('ADMIN');
	const currentUserId = useGlobalStoreSelector((s) => s.user?.id);

	const isSelf = userId === currentUserId;
	// Admins can view (and edit) any employee, themselves included. A non-admin
	// may only see their own profile, and then strictly read-only.
	const canView = isAdmin || isSelf;
	const readOnly = !isAdmin;

	if (!canView) {
		return (
			<div className="flex h-full flex-col">
				<GenericPageHeader title={t`Competence profile`} />
				<div className="flex flex-1 items-center justify-center">
					<div className="space-y-2 text-center">
						<ShieldAlert className="mx-auto size-10 text-muted-foreground" />
						<p className="text-sm font-medium text-foreground">
							<Trans>Access Denied</Trans>
						</p>
						<p className="text-xs text-muted-foreground">
							<Trans>Employee competence profiles are only available to administrators.</Trans>
						</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<CompetenceProfilePage
			userId={userId}
			breadcrumbLabel={t`Competence profile`}
			readOnly={readOnly}
			showMatrixBreadcrumb={isAdmin && !isSelf}
		/>
	);
}

export const Route = createFileRoute('/_authenticated/_app/competence/user/$userId')({
	component: CompetenceUserProfileRoute,
});
